import { render, staticRenderFns } from "./StatisticsModal.vue?vue&type=template&id=42018968&scoped=true"
import script from "./StatisticsModal.vue?vue&type=script&lang=js"
export * from "./StatisticsModal.vue?vue&type=script&lang=js"
import style0 from "./StatisticsModal.vue?vue&type=style&index=0&id=42018968&prod&lang=css"
import style1 from "./StatisticsModal.vue?vue&type=style&index=1&id=42018968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42018968",
  null
  
)

export default component.exports